import { useLocation, useNavigate } from "react-router-dom";

import PillTab from "../shared/PillTab/PillTab";
import PillTabMenu from "../shared/PillTab/PillTabMenu";

const tabs = [
  { label: "Setting definitions", to: "/settings" },
  { label: "Sync tracker", to: "/settings/sync-tracker" },
];

/** Switches between the pages under Settings. Each is its own route, so a tab can be linked to. */
export default function SettingsTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const current = pathname.replace(/\/+$/, "");

  return (
    <PillTabMenu ariaLabel="Settings sections">
      {tabs.map((tab) => (
        <PillTab key={tab.to} label={tab.label} active={current === tab.to} onClick={() => navigate(tab.to)} />
      ))}
    </PillTabMenu>
  );
}
